import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

interface ActivityFiltersProps {
  actionType: string;
  statusCode: string;
  limit: number;
  onActionTypeChange: (value: string) => void;
  onStatusCodeChange: (value: string) => void;
  onLimitChange: (value: number) => void;
  onClear: () => void;
  onRefresh: () => void;
}

export function ActivityFilters({
  actionType,
  statusCode,
  limit,
  onActionTypeChange,
  onStatusCodeChange,
  onLimitChange,
  onClear,
  onRefresh,
}: ActivityFiltersProps) {
  return (
    <div className="bg-neutral-50 dark:bg-neutral-800 rounded-lg border border-neutral-300 dark:border-neutral-700 p-6 mb-6">
      <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-4">Filters</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Input
          label="Action Type"
          type="text"
          value={actionType}
          onChange={(e) => onActionTypeChange(e.target.value)}
          placeholder="e.g. conversation.create"
        />
        <Input
          label="Status Code"
          type="number"
          value={statusCode}
          onChange={(e) => onStatusCodeChange(e.target.value)}
          placeholder="e.g. 200, 404, 500"
        />
        <div>
          <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
            Limit
          </label>
          <select
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            className="w-full px-4 py-2 bg-neutral-100 dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 rounded-lg text-neutral-900 dark:text-neutral-100 focus:outline-none focus:ring-2 focus:ring-blue-500 h-11"
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={250}>250</option>
          </select>
        </div>
      </div>
      <div className="mt-4 flex gap-2">
        <Button variant="secondary" onClick={onClear}>
          Clear Filters
        </Button>
        <Button variant="primary" onClick={onRefresh}>
          Refresh
        </Button>
      </div>
    </div>
  );
}
